import { t } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";
import { useAtomValue } from "jotai";

import { useToast } from "@whoosh/design-system/src/components/overlay/Toast/useToast";

import { useMutationWithError } from "../../../../../utils/hooks/useMutationWithError";
import { UpdateEmailOrPhoneProfileCompleteActionAtom } from "../atoms/stores";
import { useVerifyAndAssignEmailCodeProfileMutation } from "./__generated__/useVerifyAndAssignEmailCodeProfileMutation.graphql";

export const useVerifyAndAssignEmailCodeProfile = () => {
  const [verifyAndAssignEmailCode, isVerifyingAndAssigning] =
    useMutationWithError<useVerifyAndAssignEmailCodeProfileMutation>(
      useVerifyAndAssignEmailCodeProfileMutationString
    );
  const completeAction = useAtomValue(
    UpdateEmailOrPhoneProfileCompleteActionAtom
  );

  const { showToast } = useToast();
  const handleEmailCodeVerification = ({
    email,
    code,
    onError,
  }: {
    email: string;
    code: string;
    onError: () => void;
  }) => {
    verifyAndAssignEmailCode({
      variables: { input: { email, code } },
      onCompleted: (res) => {
        showToast({
          description: t`Your email address has been updated.`,
          semanticStyle: "success",
          toastId: "email-address-updated",
        });
        completeAction?.();
      },
      onCompletedErrorCustom(errors) {
        onError();
        return errors;
      },
    });
  };
  return [handleEmailCodeVerification, isVerifyingAndAssigning] as const;
};
export const useVerifyAndAssignEmailCodeProfileMutationString = graphql`
  mutation useVerifyAndAssignEmailCodeProfileMutation(
    $input: VerifyAndAssignEmailInput!
  ) {
    responsePayload: verifyAndAssignEmail(input: $input) {
      success
      errors {
        field
        code
        message
      }
      user {
        id
        email
        ... on MemberUser {
          id
          firstName
          lastName
          email
          phoneNumber {
            nationalNumber
          }
        }
      }
    }
  }
`;
